// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const EnvLabelContainer = styled.div `
  .root-app_env-label-container {
    text-align: center;
    background-color: var(--color-action-default);

    .root-app_env-label {
      margin: 0;
      line-height: 1.5em;
      font-weight: bold;
      color: var(--color-contrast-brand);
    }
  }
`;
//# sourceMappingURL=style.js.map